import { Attribute, Component, ElementRef, HostBinding, NgZone, OnInit, ViewChild } from '@angular/core';
import {catchError, map, Observable, of, Subject, takeUntil} from "rxjs";
import { Message, MessageService } from "primeng/api";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { SignupModel } from "../../models/signup/signup.model";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { DropdownHelperModel } from '../../models/helpers/dropdown-helper.model';
import { Router } from '@angular/router';
import { UserModel } from "../../models/user/user.model";
import { JwtHelperService } from "@auth0/angular-jwt";
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  //#region Fields
  @ViewChild('search') searchElementRef: ElementRef;
  public unsubscribe: Subject<void> = new Subject<void>()
  public signupModel: SignupModel = new SignupModel();
  public errorModel: { [k: string]: any } = {};
  public errorMsg: Message[];
  public counries: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public passwordMatchErrorMessage = "INFO.PASSWORD_MATCH";
  public spinner: boolean = false;
  public invalidPasswordErrorMessage = "INFO.INVALID_PASSWORD";
  public invalidAddressHelper: boolean = false;
  public invalidAddressMessage = "INFO.INVALID_ADDRESS";
  //apiLoaded: Observable<boolean>;
  public autocomplete: google.maps.places.Autocomplete;
  //#endregion

  //#region Constructor
  @HostBinding('attr.autocomplete') auto: any;
  constructor(
    public _router: Router,
    @Attribute('autocomplete') autocomplete: string,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    private _jwtHelperService: JwtHelperService,
    private ngZone: NgZone,
    private httpClient: HttpClient
    ) {
      this.auto = autocomplete || 'off'
    // TODO: Might need to be changed -> use GoogleMapsModule from '@angular/google-maps'
    /* this.apiLoaded = httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=AIzaSyDySCASHdVWlvrUOWD1nb41QKi7FLaATo4', 'callback')
    .pipe(
      map(() => true),
      catchError(() => of(false)),
    );*/
  }

  ngOnInit(): void {
    this.getallcountrynames();
  }
  //#endregion

  //#region Public Methods
  public signup(model: SignupModel) {
    this.errorModel = {};
    this.errorMsg = [];

    model.languageId = this.languageIdFromLocalStorage();

    if (!model.firstName || model.firstName == "") {
      this.errorModel['FirstName'] = this.requiredFieldErrorMessage;
    }
    if (!model.lastName || model.lastName == "") {
      this.errorModel['LastName'] = this.requiredFieldErrorMessage;
    }
    if (!model.password || model.password == "") {
      this.errorModel['Password'] = this.requiredFieldErrorMessage;
    } else if (!this.isPasswordValid()) {
      this.errorModel['Password'] = this.invalidPasswordErrorMessage;
    }
    if (!model.confirmPassword || model.confirmPassword == "") {
      this.errorModel['ConfirmPassword'] = this.requiredFieldErrorMessage;
    }
    if (model.confirmPassword && model.password && model.confirmPassword !== model.password) {
      this.errorModel['ConfirmPassword'] = this.passwordMatchErrorMessage;
    }
    if (!model.address || model.address == "") {
      this.errorModel['Address'] = this.requiredFieldErrorMessage;
    }
    if (model.address && model.address != "" &&  this.invalidAddressHelper) {
      this.errorModel['Address'] = this.invalidAddressMessage;
    }
    if (!model.companyName || model.companyName == "") {
      this.errorModel['CompanyName'] = this.requiredFieldErrorMessage;
    }
    if (!model.countryId) {
      this.errorModel['Country'] = this.requiredFieldErrorMessage;
    }
    if (!model.email || model.email == "") {
      this.errorModel['Email'] = this.requiredFieldErrorMessage;
    }
    if (!model.phone || model.phone == "") {
      this.errorModel['Phone'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {

      const countryName = this.counries.find(x => x.id === model.countryId);
      if (countryName) {
        model.countryName = (countryName as any).countryName;
      }

      model.phone = model.phone.toString();

      this.spinner = true;

      this.authenticationService.signup(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            localStorage.setItem('resy_access_token', response.jwtToken);
            localStorage.setItem('resy_refresh_token', response.refreshToken);
            const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
            const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
            this.spinner = false;
            this.authenticationService.loginUser.next(loggedInUser);
            this._router.navigateByUrl('venues');
            },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error.errors && errorResponse.error.errors.FirstName) {
              errorResponse.error.errors.FirstName.forEach((error: string) => {
                this.errorModel['FirstName'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.LastName) {
              errorResponse.error.errors.LastName.forEach((error: string) => {
                this.errorModel['LastName'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Password) {
              errorResponse.error.errors.Password.forEach((error: string) => {
                this.errorModel['Password'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.ConfirmPassword) {
              errorResponse.error.errors.ConfirmPassword.forEach((error: string) => {
                this.errorModel['ConfirmPassword'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Email) {
              errorResponse.error.errors.Email.forEach((error: string) => {
                this.errorModel['Email'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Phone) {
              errorResponse.error.errors.Phone.forEach((error: string) => {
                this.errorModel['Phone'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Address) {
              errorResponse.error.errors.Address.forEach((error: string) => {
                this.errorModel['Address'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.CompanyName) {
              errorResponse.error.errors.CompanyName.forEach((error: string) => {
                this.errorModel['CompanyName'] = error;
              });
            }
            if (errorResponse.error.errors && errorResponse.error.errors.Country) {
              errorResponse.error.errors.Country.forEach((error: string) => {
                this.errorModel['Country'] = error;
              });
            }
            else if (errorResponse.error && errorResponse.error.Message) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.Message, life: 2000 });
            }
          }
        });
    }
  }

  public hasUppercaseLetter(): boolean {
    return this.signupModel.password !== undefined && (/[A-Z]/).test(this.signupModel.password);
  }

  public hasLowercaseLetter(): boolean {
    return this.signupModel.password !== undefined && (/[a-z]/).test(this.signupModel.password);
  }

  public hasSpecialCharacter(): boolean {
    return this.signupModel.password !== undefined && (/[!$%@#£€*?&.,:]/).test(this.signupModel.password);
  }

  public has8Characters(): boolean {
    return this.signupModel.password !== undefined && (/.{8,}/).test(this.signupModel.password);
  }

  public isPasswordValid(): boolean {
    return this.signupModel.password !== undefined && (/^(?=.*[A-Z])(?=.*[a-z])(?=.*[!$%@#£€*?&.,:])(?!.*\s).{8,}$/).test(this.signupModel.password);
  }

  public openTooltip(tipContent: NgbTooltip): void {
    if (!tipContent.isOpen()) {
      tipContent.open();
    }
  }

  public closeTooltip(tipContent: NgbTooltip): void {
    tipContent.close();
  }

  public getallcountrynames() {
    this.authenticationService.getAllCountryNames()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.counries = response;
        },
        error: errorResponse => {
        }
      }
      )
  }

  languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }

  public changeCountry($event: any): void {
    this.signupModel.address = '';
    this.counries.forEach((element) => {
      if (element.id == $event.value) {
        this.findAddress(element.countryCode);
      }
    });
  }

  public findAddress(countryCode: string): void {
    if (countryCode) {
      // TODO: Needs to be changed -> use GoogleMapsModule from '@angular/google-maps'

      /*    this.mapsAPILoader.load().then(() => {
          if (!this.autocomplete) {
            this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
              componentRestrictions: {country: countryCode}
            });
          } else {
            this.autocomplete.setComponentRestrictions({country: countryCode});
          }
          this.autocomplete.addListener("place_changed", () => {
            this.ngZone.run(() => {
              this.errorModel['Address'] = null;
              this.invalidAddressHelper = true;
              let place: google.maps.places.PlaceResult = this.autocomplete!.getPlace();
              if (!place || !place.geometry) {
                return;
              }
              this.invalidAddressHelper = !place.geometry?.location.lat() && !place.geometry?.location.lng();
              if (place.formatted_address) {
                this.signupModel.address = place.formatted_address;
              }
            });
          });
        });*/
    }
  }

  public onAddressManualChange(): void {
    this.invalidAddressHelper = true;
  }

  public cancel(): void {
    this._router.navigateByUrl('login');
  }
  //#endregion
}
